import { gql } from "@/graphql/generated/gql";

export const getPartnerBySubdomainQuery = gql(`
  query getPartnerBySubdomain($subdomain: String!) {
    getPartnerBySubdomain(data: { subdomain: $subdomain }) {
      subdomain
      providerId
      widgetColor
      widgetLogo
      apiKey
      category
    }
  }
`);

export const getProviderQuery = gql(`
  query getProvider($id: String!) {
    getProvider(id: $id) {
      name
    }
  }
`);

export const checkChargeQuery = gql(`
  query CheckCharge($data: CheckChargeInput!) {
    checkCharge(data: $data) {
      chargeResponse {
        id
        status
        reference
        amount
        message
        gateway_response
        paid_at
        channel
        currency
        authorization {
          authorization_code
          bin
          last4
          exp_month
          exp_year
          channel
          card_type
          bank
          country_code
          brand
          reusable
          signature
          account_name
        }
      }
    }
  }
`)

export const getWellaHealthPharmaciesQuery = gql(`
  query getPharmaciesFromWellaHealth($lga: String, $state: String!) {
    getPharmaciesFromWellaHealth(data: { state: $state, lga: $lga }) {
      data {
        pharmacyCode
        pharmacyName
        state
        lga
        area
        address
      }
    }
  }
`);
export const getLeadwayPharmaciesQuery = gql(`
  query getPharmaciesFromLeadway($lga: String, $state: String!) {
    getPharmaciesFromLeadway(data: { state: $state, lga: $lga }) {
      data {
        pharmacyCode
      pharmacyName
      state
      lga
      area
      source
      address
      }
    }
  }
`);


export const prescriptionReferralQuery = gql(`
  query PrescriptionReferral($id: String!) {
    prescriptionReferral(data: {id: $id}) {
      _id
      patient {
        _id
        phoneNumber
        email
      }
      doctor {
        _id
      }
      consultation {
        _id
        pharmacyCode
        pharmacyName
        pharmacyAddress
      }
      drugsPartner {
        _id
      }
    }
  }
`);

export const getPartnerConfigurationQuery = gql(`
  query GetPartnerConfiguration($partnerId: String!) {
    getPartnerConfiguration(data: {
      partner: $partnerId
    }) {
      partner # partner ID
      drugDeliveryFee
      drugPriceMarkUp
      testPriceMarkup
      testPickUpFee
    }
  }
`);


export const getRejectedDrugsQuery = gql(`
  query GetRejectedDrugs($referralId: String!) {
    getRejectedDrugs(data: {
      id: $referralId
    }) {
      account {
        access_token
      }
      drugs {
        _id
        amount
        drugForm
        drugName
        quantity
      }
    }
  }
`);

export const enrolleeDrugOrderMutation = gql(`
  mutation EnrolleeDrugOrder($data: EnrolleeOrderInput!) {
    enrolleeDrugOrder(data: $data) {
      drugOrder {
        _id
      }
    }
  }
`);

export const initPaymentMutation = gql(`
  mutation InitPayment($data: PaymentInitInput!) {
    initPayment(data: $data) {
      paymentInitResponse {
        authorization_url
        reference
      }
      errors {
        field
        message
      }
    }
  }
`);

export const getDrugOrderQuery = gql(`
  query GetDrugOrder($id: String!) {
    getDrugOrder(data: {
      id: $id
    }) {
      _id
      createdAt
      prescriptions {
        drugName
        drugForm
        quantity
        dosageUnit
        markedUpDrugPrice
      }
      userLocation {
        address
        city
        landmark
        state
      }
      deliveryFee
      deliveryOption
      trackingLink
      total
      orderId
      pharmacyAddress
      pharmacyCode
      pharmacyName
    }
  }
`);

export const getRejectedTestsQuery = gql(`
  query GetRejectedTests($referralId: String!) {
  getRejectedTests(data: {
    id: $referralId
  }) {
    tests {
      _id
      name
      price
    }
    account {
      access_token
    }
  }
}
`)

export const enrolleeTestOrderMutation = gql(`
  mutation EnrolleeTestOrder($data: EnrolleeTestOrderInput!) {
    enrolleeTestOrder(data: $data) {
      diagnosticTest {
        _id
      }
    }
  }
`);

export const getFeaturedDiagnosticsPartnerQuery = gql(`
  query GetFeaturedDiagnosticsPartner {
    getFeaturedPartner(data: {
      category: "diagnostics"
    }) {
      providerId
      name
    }
  }
`);

export const getDiagnosticTestQuery = gql(`
  query GetDiagnosticTest($data: DiagnosticInput!) {
    getDiagnosticTest(data: $data) {
      _id
      createdAt
      total
      tests {
        markedUpTestPrice
        name
      }
    }
  }  
`)